type Props = {
  gadgetId: string
}

export default function Letro({ gadgetId }: Props) {
  return <div className="letroUgcsetGadget" data-contents="letro-gadget" data-gadget-id={gadgetId} />
}
